import React from "react";
import { Box } from "@mui/material";

import Alert from "../GenericComponents/Alert";
import "./AlertsContainer.css";

const AlertsContainer = () => {
  return (
    <Box className="alerts-box">
      <Alert status="Info" message="" alertType="single" />
    </Box>
  );
};

export default AlertsContainer;
